import { requestWithAuth } from "@/utils/authUtils";

const ForumService = {
  async listThreads(limit) {
    const query = limit ? `?limit=${limit}` : "";
    return await requestWithAuth(`/forum/threads${query}`, "GET");
  },

  async createThread({ title, body }) {
    return await requestWithAuth("/forum/threads", "POST", { title, body });
  },

  async getThread(threadId) {
    return await requestWithAuth(`/forum/threads/${threadId}`, "GET");
  },

  async createComment(threadId, body) {
    return await requestWithAuth(
      `/forum/threads/${threadId}/comments`,
      "POST",
      { body }
    );
  },

  async recordView(threadId) {
    return await requestWithAuth(
      `/forum/threads/${threadId}/views`,
      "POST",
      {}
    );
  },

  async upvoteThread(threadId) {
    return await requestWithAuth(
      `/forum/threads/${threadId}/upvote`,
      "POST",
      {}
    );
  },

  async upvoteComment(commentId) {
    return await requestWithAuth(
      `/forum/comments/${commentId}/upvote`,
      "POST",
      {}
    );
  },

  async deleteThread(threadId) {
    return await requestWithAuth(`/forum/threads/${threadId}`, "DELETE");
  },
};

export default ForumService;
